const Invoices = () => {
    return (
        <h1>Invoices</h1>
    )
}

export default Invoices;